<template>

    <trax-ui-ajax-table-with-crud-actions
        :id="id" :titles="titles" :props="props" :bus="bus"
        :endpoint="endpoint" :delete="false" :paging="false">
    </trax-ui-ajax-table-with-crud-actions>

</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            endpoint: null
        },

        data: function() {
            return {
                lang: lang,
                titles: [
                    lang.polaris.settings.background_image,
                    lang.polaris.form.name,
                    lang.polaris.form.status,
                    ''
                ],
                props: [
                    {source: this.image, class: 'trax-background-thumbnail'},
                    {source: 'name'},
                    {source: this.status}
                ]
            }
        },

        // Clicking a thumbnail sends the image to the preview card. The rows are
        // redrawn by datatables, so the handler is delegated to the table body.

        mounted: function() {
            var that = this;

            $('#'+this.id+'-table tbody').on('click', 'td.trax-background-thumbnail img', function() {
                var row = $('#'+that.id+'-table').DataTable().row($(this).parents('tr')).data();
                if (row) {
                    that.bus.$emit(that.id+'-preview', row);
                }
            });
        },

        methods: {

            // Columns rendering

            image(data, type, row, meta) {
                return '<img src="' + row.url + '" alt="' + row.code + '">';
            },

            status(data, type, row, meta) {
                if (row.active) {
                    return '<span class="badge badge-success">'
                        + this.lang.polaris.settings.background_enabled + '</span>';
                }
                return '<span class="badge badge-default">'
                    + this.lang.polaris.settings.background_disabled + '</span>';
            }
        }

    }
</script>
